import React, { useEffect, useState } from "react";
import { useParams, useHistory } from "react-router-dom";

import * as decoValidation from "./validations/decoMethodValidations";
import DecoMethodService from "../../../../services/DecoMethodService";
import DecoMethodsForm from "./forms/DecoMethodsForm";

function DecoMethodsAddEdit() {
  const { id } = useParams();
  let history = useHistory();
  const errorsDefaultStateValue = {
    name: null,
    hyphanateName: null,
    ppcName: null,
    productExamples: null,
    colorsMax: null,
    colorPricingCategoryID: null,
  };
  const [formErrors, setFormErrors] = useState(errorsDefaultStateValue);
  const [data, setData] = useState({
    dM_ID: 0,
    name: "",
    hyphanateName: "",
    ppcName: "",
    productExamples: "",
    colorsMax: "",
    colorPricingCategoryID: null,
    active: false,
  });

  const getData = async () => {
    const result = await DecoMethodService.getOne(id);
    if (id && result) setData(result);
  };

  useEffect(() => {
    getData();
  }, []);

  const saveDecoMethod = async () => {
    const postData = {
      Id: id,
      DecoName: data.name,
      DecoHyphanateName: data.hyphanateName,
      PPCName : data.ppcName,
      ProductExamples: data.productExamples,
      ColorsMax: data.colorsMax,
      ColorPricingCategoryId: data.colorPricingCategoryID,
    };
    // return console.log(postData);
    if (id) {
      const result = await DecoMethodService.update(postData);
      if (result.success === true) history.goBack();
    } else {
      const result = await DecoMethodService.add(postData);
      if (result.success === true) history.goBack();
    }
  };

  const validateForm = () => {
    debugger;
    const errorList = { ...errorsDefaultStateValue };
    errorList.name = decoValidation.name(data.name);
    errorList.hyphanateName = decoValidation.hyphanateName(data.hyphanateName);
    errorList.ppcName = decoValidation.ppcName(data.ppcName);
    errorList.productExamples = decoValidation.productExamples(
      data.productExamples
    );
    errorList.colorsMax = decoValidation.colorsMax(data.colorsMax);
    errorList.colorPricingCategoryID = decoValidation.colorPricingCategoryID(
      data.colorPricingCategoryID
    );

    setFormErrors(errorList);

    const errorCount = Object.values(errorList).filter((em) => em != null)
      .length;
    return errorCount < 1;
  };

  const saveHandler = (event) => {
    debugger;
    event.preventDefault();
    if (validateForm()) {
      saveDecoMethod();
    }
  };

  return (
    <div>
      <h4>{id ? "Edit" : "New"} Deco Method</h4>
      <hr />
      <DecoMethodsForm
        formData={data}
        setFormData={setData}
        formErrors={formErrors}
        setFormErrors={setFormErrors}
      />
      <hr />
      <div className="d-flex justify-content-center">
        <button
          className="btn btn-sm btn-danger mr-5"
          onClick={(e) => history.goBack()}
        >
          Cancel
        </button>
        <button
          type="button"
          onClick={saveHandler}
          className="btn btn-sm btn-success"
        >
          Save
        </button>
      </div>
    </div>
  );
}

export default DecoMethodsAddEdit;
